import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-rangeslider';
import _ from 'lodash';

class PreferencesCommonFilterSlider extends Component {
  constructor(props) {
    super(props);
    const keys = props.field.dbKey.split('.');
    this.state = {
      sliderValue: props.modifiedPreferences !== undefined &&
      !_.isEmpty(props.modifiedPreferences) &&
      props.modifiedPreferences[keys[0]][keys[1]] !== undefined ?
      props.modifiedPreferences[keys[0]][keys[1]] : 0,
    };
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { field, modifiedPreferences } = this.props;
    const keys = field.dbKey.split('.');
    if (nextProps.modifiedPreferences && (!_.isEmpty(nextProps.modifiedPreferences))
    && _.isEmpty(modifiedPreferences)) {
      this.setState({
        sliderValue: nextProps.modifiedPreferences[keys[0]][keys[1]] || 0,
      });
    } else if ((!_.isEmpty(modifiedPreferences)) &&
    modifiedPreferences[keys[0]][keys[1]] !== nextProps.modifiedPreferences[keys[0]][keys[1]]) {
      this.setState({
        sliderValue: nextProps.modifiedPreferences[keys[0]][keys[1]] || 0,
      });
    }
  }

  handleVpctSliderChange = value => {
    this.setState({
      sliderValue: value,
    }, () => {
      this.props.updatePreferences(this.props.field.dbKey, this.state.sliderValue);
    });
  };

  handleLabel = () => {
    const { field } = this.props;
    const { sliderValue } = this.state;
    let label = `${sliderValue}%`;
    const keys = field.dbKey.split('.');
    if (keys[1] === '_rfs') {
      label = `${this.state.sliderValue}%`;
    }
    if (keys[1] === '_smfs' || keys[1] === '_ssmfs' || keys[1] === '_wsmfs') {
      label = `${this.state.sliderValue}`;
    }
    return label;
  }

  render() {
    const { field } = this.props;
    return (
      <div className="preferences-cmn-data-input common-filter-slider">
        <div className="perFilterStartLabel">{field.filterStartLabel}</div>
        <div className="columns custom-rangeslider-horizontal">
          <Slider
            min={field.minValue}
            max={field.maxValue}
            value={this.state.sliderValue}
            orientation="horizontal"
            tooltip={false}
            onChange={this.handleVpctSliderChange}
            labels={{}}
            handleLabel={this.handleLabel()}
          />
        </div>
        <div className="percentage-filter-clmn text-align-left">
          <span className="perFilterEndLabel">{field.filterEndLabel}</span>
        </div>
      </div>
    );
  }
}

PreferencesCommonFilterSlider.propTypes = {
  field: PropTypes.shape({
    style: PropTypes.shape({}),
    dbKey: PropTypes.string,
    filterStartLabel: PropTypes.string,
    filterEndLabel: PropTypes.string,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
  }),
  modifiedPreferences: PropTypes.shape({}),
  updatePreferences: PropTypes.func,
};

export default PreferencesCommonFilterSlider;
